import React, { useState } from 'react';
import { useEvents } from '../contexts/EventContext';
import { useAuth } from '../contexts/AuthContext';
import { useSport } from '../contexts/SportContext';
import { motion, AnimatePresence } from 'framer-motion';
import ParticipantSlider from './ParticipantSlider';
import { useTranslation } from 'react-i18next';

const EventDetails = ({ event, onClose }) => {
    const { joinEvent } = useEvents();
    const { user } = useAuth();
    const { sportTypes } = useSport();
    const { t, i18n } = useTranslation();

    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [optimisticStatus, setOptimisticStatus] = useState(null);
    const [zoomedImage, setZoomedImage] = useState(null);

    if (!user || !event) return null;

    const acceptedParticipants = event.participants ? event.participants.filter(p => p.status === 'accepted') : [];
    const myParticipation = event.participants ? event.participants.find(p => p.user_id === user.id) : null;
    const isCreator = event.user_id === user.id;

    const handleJoin = async () => {
        setLoading(true);
        setMessage('');
        setOptimisticStatus(event.is_public ? 'accepted' : 'pending');
        try {
            const response = await joinEvent(event.id);
            if (response && response.data && response.data.message) {
                setMessage(response.data.message);
            }
        } catch (err) {
            setMessage(err.toString());
            setOptimisticStatus(null);
        } finally {
            setLoading(false);
        }
    };

    const getActionButton = () => {
        const currentStatus = optimisticStatus || myParticipation?.status;
        if (isCreator) return <p style={{textAlign: 'center', fontWeight: '600'}}>{t('hosting_this_vibe')}</p>;
        if (currentStatus === 'accepted') return <p style={{textAlign: 'center', fontWeight: '600', color: 'var(--color-success-glow)', textShadow: '0 0 5px rgba(0,0,0,0.5)'}}>{t('you_are_in')}</p>;
        if (currentStatus === 'pending') return <p style={{textAlign: 'center', fontWeight: '600'}}>{t('request_is_pending')}</p>;
        return <button onClick={handleJoin} disabled={loading} className="button-primary">{loading ? t('loading') : (event.is_public ? t('join_now_button') : t('request_to_join_button'))}</button>;
    };
    
    return (
        <>
            <div className="modal-backdrop" onClick={onClose}>
                <motion.div 
                    className="modal-content"
                    onClick={e => e.stopPropagation()}
                    initial={{ scale: 0.8, opacity: 0 }} 
                    animate={{ scale: 1, opacity: 1 }} 
                    exit={{ scale: 0.8, opacity: 0 }} 
                    transition={{ type: "spring", stiffness: 120, damping: 20 }}
                    style={{ padding: 0, overflow: 'hidden' }}
                >
                    <div style={{ padding: '20px 20px 15px 20px', background: 'rgba(0,0,0,0.2)' }}>
                        <h2 style={{ margin: '0 0 5px 0', fontFamily: 'var(--font-display)', fontSize: '2em', textAlign: 'center' }}>
                            {sportTypes[event.sport_type]?.icon} {event.title}
                        </h2>
                        <p style={{ fontSize: '1em', margin: '0 0 10px 0', textAlign: 'center', color: 'var(--color-text-normal)', textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000' }}>
                            {new Date(event.event_date).toLocaleString(i18n.language, { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                        </p>
                    </div>
                    <div style={{ minHeight: '150px' }}>
                        <ParticipantSlider participants={acceptedParticipants} creatorId={event.user_id} onImageClick={setZoomedImage} />
                    </div>
                    <div style={{ padding: '20px', borderTop: '3px solid #000', background: 'rgba(0,0,0,0.2)' }}>
                        {message && <p style={{textAlign: 'center', margin: '0 0 15px 0'}}>{message}</p>}
                        {getActionButton()}
                    </div>
                </motion.div>
            </div>
            <AnimatePresence>
                {zoomedImage && (
                    <motion.div className="modal-backdrop" onClick={() => setZoomedImage(null)} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                        {/* Pfad zum großen Bild wird hier verwendet */}
                        <motion.img src={zoomedImage} alt="Zoomed selfie" layoutId={`participant-${zoomedImage}`} style={{ maxHeight: '80%', maxWidth: '80%', borderRadius: 'var(--border-radius-large)', boxShadow: '0 10px 40px rgba(0,0,0,0.5)', border: '3px solid #000' }} />
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};
export default EventDetails;
